import { apiClient } from './client';
import type { CelebrationTemplateData } from '@om/shared-types';

export type { CelebrationTemplateData };

/** Read-only DB-backed celebration templates (public endpoint: anonymous /quick needs it). */
export async function getCelebrationTemplates(): Promise<CelebrationTemplateData[]> {
  const response = await apiClient.get<{ success: boolean; data: CelebrationTemplateData[] }>(
    '/public/celebration-templates',
  );
  return response.data.data ?? [];
}

export async function getCelebrationTemplate(key: string): Promise<CelebrationTemplateData | null> {
  try {
    const response = await apiClient.get<{ success: boolean; data: CelebrationTemplateData }>(
      `/public/celebration-templates/${encodeURIComponent(key)}`,
    );
    return response.data.data ?? null;
  } catch (error) {
    const status = (error as { response?: { status?: number } }).response?.status;
    if (status === 404) return null;
    throw error;
  }
}
